import React, { useEffect, useState } from 'react';
import { useAlert } from './AlertContext';
import { useNavigate } from 'react-router-dom';
import { NNotification } from '@innersource-nn/novoui-react';
import { Dialog } from '@headlessui/react';

const AlertSnackbar: React.FC = () => {
    const navigate = useNavigate();
    const { state, closeAlert } = useAlert();
    const { open, title, message, severity, path } = state;
    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => {
        if (open && path) {
            if (path === '-1') {
                navigate(-1);
            } else {
                navigate(path);
            }
        }
        const timeoutId = setTimeout(() => {
            setIsOpen(false);
            closeAlert(); // Optionally close the alert when timeout occurs
        }, 5000); // 5 seconds in milliseconds

        return () => clearTimeout(timeoutId); // Clear the timeout when component unmounts
    }, [navigate, open, path, closeAlert]);

    useEffect(() => {
        if (open) {
            setIsOpen(true); // Ensure snackbar is open when `open` state changes to true
        }
    }, [open]);

    return (
        open && (
            <Dialog open={isOpen} onClose={() => setIsOpen(false)} static>
                <div className="fixed inset-x-0 top-8 flex items-center justify-center z-50">
                    <NNotification
                        title={title}
                        content={message}
                        type={severity}
                        onClose={closeAlert}
                        className="lg:w-1/2 2xl:w-1/3"
                    />
                </div>
            </Dialog>
        )
    );
};

export default AlertSnackbar;
